import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-lymphatic-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-lymphatic-walking-f', 'age-lymphatic-walking-f'],
		route: {
			path: '/lymphatic-walking-f',
			name: 'lymphatic-walking-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-lymphatic-walking',
		route: {
			path: '/lymphatic-walking-f/ob/:page(.*)?',
			name: 'activity-female-lymphatic-walking',
		},
		slug: 'activity-female-lymphatic-walking',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-lymphatic-walking-f',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-lymphatic-walking-f-us',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-lymphatic-walking-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
}

export default appAreaConfig
